import React from 'react';
import GradeMindApp from './grademind/GradeMindApp';

function App() {
  return <GradeMindApp />;
}

export default App;
